import { Card, Metric } from '../../blocks';
import { useClientUser } from '@/hooks';
import { carrierDisplayName } from '@/utilities/carrierAlias';
import { Grid } from '@material-ui/core';
import { ageFormatter, dateFormatter } from '../../formatters';
import { CLAIM_TYPES } from '../../constants';

const ClaimInfoCard = ({ claim }) => {
    const { partnerCarriersById } = useClientUser();

    return (
        <Card>
            <Grid item>
                <Metric
                    label="Order"
                    value={[claim.order.order_number, claim.order.po_number, claim.order.reference_id]
                        .filter((x) => !!x)
                        .join(' / ')}
                />
            </Grid>
            <Grid item>
                <Metric label="Submitted Date" value={claim.created_at} formatter={dateFormatter} />
            </Grid>
            <Grid item>
                <Metric label="Incident Date" value={claim.incident_date} formatter={dateFormatter} />
            </Grid>
            <Grid item>
                <Metric label="Requested By" value={claim.requested_by} />
            </Grid>
            <Grid item>
                <Metric
                    label="Carrier"
                    value={carrierDisplayName(claim.carrier || claim.middle_mile_carrier, partnerCarriersById)}
                />
            </Grid>
            <Grid item>
                <Metric label="Age of Claim" value={claim.created_at} formatter={ageFormatter} />
            </Grid>
            <Grid item>
                <Metric label="Claim Type" value={CLAIM_TYPES[claim.claim_type]} />
            </Grid>
        </Card>
    );
};

export default ClaimInfoCard;
